import {
  aiReelGeneratorURL,
  aiRemovalURL,
  aiTiktokVideoURL,
  aiTwinGeneratorURL,
  aiUgcVideoURL,
  aiVideoEditURL,
  avatarVideoProURL,
  dropshippingVideoAdsURL,
  facebookVideoAdURL,
  faceSwapperURL,
  gptImage2URL,
  imageEnhanceURL,
  imageGenerateURL,
  imageTranslationURL,
  productAvatarURL,
  seedance20URL,
  // sora2ProURL,
  videoGenerateURL,
  videoTranslateURL,
  voiceCloneURL,
} from '@/utils/routeConstants';

/** 与 LandingHeader NAV_MENUS 中各子项 href 一致 */
export type HomeHeaderNavLink = { key: string; label: string; href: string };

/** Features 下拉：AI Video → AI Avatar → AI Image */
export const NEW_HOME_FEATURE_GROUPS: {
  key: string;
  label: string;
  links: HomeHeaderNavLink[];
}[] = [
  {
    key: 'ai-video',
    label: 'AI Video',
    links: [
      { key: 'ai-video-generator', label: 'AI Video Generator', href: videoGenerateURL },
      { key: 'ai-video-editor', label: 'AI Video Editor', href: aiVideoEditURL },
      { key: 'video-translator', label: 'Video Translation', href: videoTranslateURL },
      { key: 'face-swap', label: 'Face Swap', href: faceSwapperURL },
    ],
  },
  {
    key: 'ai-avatar',
    label: 'AI Avatar',
    links: [
      {
        key: 'ai-avatar-generator',
        label: 'AI Avatar Generator',
        href: avatarVideoProURL,
      },
      { key: 'ai-product-avatar', label: 'Product Avatar', href: productAvatarURL },
      { key: 'ai-voice-cloning', label: 'Voice Clone', href: voiceCloneURL },
    ],
  },
  {
    key: 'ai-image',
    label: 'AI Image',
    links: [
      { key: 'ai-image-generator', label: 'AI Image Generator', href: imageGenerateURL },
      {
        key: 'ai-image-translator',
        label: 'Image Translation',
        href: imageTranslationURL,
      },
      { key: 'ai-image-enhancer', label: 'Image Enhance', href: imageEnhanceURL },
      { key: 'video-subtitle-remover', label: 'AI Removal', href: aiRemovalURL },
    ],
  },
];

/** Use Cases 下拉：与 LandingHeader use-cases 一致 */
export const NEW_HOME_USE_CASE_LINKS: HomeHeaderNavLink[] = [
  {
    key: 'ai-tiktok-video-generator',
    label: 'AI TikTok Video Generator',
    href: aiTiktokVideoURL,
  },
  { key: 'ai-ugc-video-generator', label: 'AI UGC Video Generator', href: aiUgcVideoURL },
  { key: 'ai-twin-generator', label: 'AI Twin Generator', href: aiTwinGeneratorURL },
  // { key: 'sora-2-pro', label: 'Sora 2 Pro', href: sora2ProURL },
  { key: 'seedance-2-0', label: 'Seedance 2.0', href: seedance20URL },
  { key: 'gpt-image-2', label: 'GPT Image 2', href: gptImage2URL },
  {
    key: 'facebook-video-ad-creator',
    label: 'Facebook Video Ad Creator',
    href: facebookVideoAdURL,
  },
  {
    key: 'dropshipping-video-ads-maker',
    label: 'Dropshipping Video Ads Maker',
    href: dropshippingVideoAdsURL,
  },
  { key: 'ai-reel-generator', label: 'AI Reel Generator', href: aiReelGeneratorURL },
];
